// Where the numbers come from, with thanks (DIRECTION D1, B-592).
//
// Every player, game and stat on the site is open data somebody else built and
// shares freely, and the least the site owes them is to say so plainly: each
// source by name with a link to it, the sentence its license asks for exactly
// as it asks, and the license itself a press away. The lines are the server's
// (`GET /api/credits`, from the source manifests), so a source added is
// credited here without this file changing.
//
// PUBLIC, AND OUTSIDE `Shell`, as Privacy is: a visitor reads it from the
// front page's foot before any account exists. Its own scroll, since the
// browser never scrolls (DESIGN §4), and a way back to wherever it was opened
// from.

import { useNavigate } from 'react-router-dom';
import { valueOf } from '@fsp/domain';
import { BRAND } from '../branding';
import { useCredits } from '../data/credits';
import { Button, Callout, Card, Heading, Line, Stack, Text, Title } from '../kit/ui';
import '../styles/screens/account.css';

export function CreditsScreen() {
  const navigate = useNavigate();
  const credits = useCredits();
  const lines = valueOf(credits.snapshot)?.lines ?? null;
  return (
    <div className="fsp-privacy-page">
      <div className="fsp-about fsp-privacy">
        <Stack gap={5}>
          <div>
            <Button
              size="xs"
              variant="quiet"
              icon="back"
              // Back where it was opened from; opened on its own, the front page.
              onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
            >
              Back
            </Button>
          </div>
          <Stack gap={1}>
            <Title>Credits</Title>
            <Text tone="secondary" block>
              {`The players, games and stats on ${BRAND.name} come from open data, built and shared freely by the people below. Thank you. (The practice league’s players are made up.)`}
            </Text>
          </Stack>

          {lines === null ? (
            credits.snapshot.state === 'failed' ? (
              <Callout tone="bad">
                <Stack gap={2}>
                  <span>{credits.snapshot.failure.message}</span>
                  <Line>
                    <Button size="xs" onClick={credits.reload}>
                      Try again
                    </Button>
                  </Line>
                </Stack>
              </Callout>
            ) : (
              <Text tone="secondary" block>
                Reading the credits…
              </Text>
            )
          ) : (
            <Stack gap={3}>
              {lines.map((line) => (
                <Card padded key={`${line.source}:${line.text}`}>
                  <Stack gap={2}>
                    <Heading>
                      {/* Theirs, in a tab of their own (DIRECTION D12). */}
                      <a
                        className="fsp-linklike"
                        href={line.homepage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {line.source}
                      </a>
                    </Heading>
                    <Text block>{line.text}</Text>
                    <Text size="sm" tone="secondary" block>
                      License:{' '}
                      <a
                        className="fsp-linklike"
                        href={line.licenseUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {line.license}
                      </a>
                    </Text>
                  </Stack>
                </Card>
              ))}
            </Stack>
          )}
        </Stack>
      </div>
    </div>
  );
}
